"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgRobotOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.53 23.16a22.09 22.09 0 00-8.71-2.75l-7-9.9 7-2.35a7.09 7.09 0 001.83 3.56l.37.35L27.16 11l-.35-2-5.06.9a4.93 4.93 0 01-1-2.92 5 5 0 011-2.92l5.06.9.35-2L21 1.93l-.37.35a7 7 0 00-1.83 3.79l-8.34 2.78a3.83 3.83 0 00-4.78-.25 4.06 4.06 0 00-1 5.55l4.69 7a19.16 19.16 0 00-4.93 2l-.44.3V28h24v-4.55zM6.34 13a2 2 0 01.49-2.8 1.92 1.92 0 012.7.53l6.73 9.5H16a24.87 24.87 0 00-4.52.41zM26 26H6v-1.42a22.07 22.07 0 0110-2.33 22.17 22.17 0 0110 2.33z" })));
}
exports.default = SvgRobotOutline;
//# sourceMappingURL=RobotOutline.js.map